import {memoize} from '@packages/utilities/memo';
import {type CollectionsType} from '@packages/systems/core/records/CollectionStateType';
import type {
  PaginationPageNumbers,
  PluginArguments,
  RuntimeEnvironment,
} from '../types';

const pluginArguments = memoize(
  (
    collections: CollectionsType,
    paginationPageNumbers: PaginationPageNumbers,
    publicationId: string,
    runtimeEnvironment: RuntimeEnvironment,
    showSampleSearchResults: boolean,
    timezone: string,
    cmsLocaleId?: string | null
  ): PluginArguments => ({
    collections,
    paginationPageNumbers,
    publicationId,
    runtimeEnvironment,
    showSampleSearchResults,
    timezone,
    cmsLocaleId,
  })
);

export const createPluginArguments = ({
  collections,
  paginationPageNumbers,
  publicationId,
  runtimeEnvironment,
  showSampleSearchResults = false,
  timezone,
  cmsLocaleId,
}: {
  collections: CollectionsType;
  paginationPageNumbers: PaginationPageNumbers;
  publicationId: string;
  runtimeEnvironment: RuntimeEnvironment;
  showSampleSearchResults?: boolean;
  timezone: string;
  cmsLocaleId: string | null | undefined;
}) =>
  pluginArguments(
    collections,
    paginationPageNumbers,
    publicationId,
    runtimeEnvironment,
    showSampleSearchResults,
    timezone,
    cmsLocaleId
  );
